import React, { FC, ReactNode } from "react";

import { ReactComponent as WelcomeImg } from "../assets/illustrations/welcome-240x240.svg";
import { Logo } from "../components/logo";
import { IntercomObserver } from "../components/observers";

type Props = {
  children?: ReactNode;
};

const AuthLayout: FC<Props> = ({ children }) => {
  return (
    <div className="w-full flex flex-row">
      <div className="basis-full lg:basis-6/12 px-4 md:px-16 pb-16 pt-4 md:pt-24">
        <div className="max-w-[592px] mx-auto">{children}</div>
      </div>

      <div className="w-6/12 basis-6/12 h-screen bg-purple-50 p-16 flex-col justify-center items-center text-center fixed right-0 top-0 hidden lg:flex">
        <div className="max-w-[600px] flex flex-col items-center text-center max-h-full">
          <WelcomeImg className="mb-16" />

          <div className="font-source-serif text-2xl leading-[54px] mb-12">
            Archway.Finance, through banking partnerships in India, allows me to
            easily receive payments to my bank account in INR. Everything within
            few hours and also with almost zero fees.
          </div>

          <div className="font-manrope text-gray-500 text-base mb-3">
            Raj Patel, India
          </div>

          <div className="font-manrope text-gray-300 text-base mb-24">
            Contractor
          </div>

          <Logo className="justify-self-end" align="vertical" />
        </div>
      </div>

      <IntercomObserver />
    </div>
  );
};

export default AuthLayout;
